import router from '@/router'
import store from '@/store'
import axios from '@/utills/axios'
router.beforeEach((to, from, next) => {
    next()
})